export var EventBusEvent;
(function (EventBusEvent) {
    EventBusEvent["ToggleSideNav"] = "TOGGLE_SIDE_NAV";
    EventBusEvent["WishlistCounterUpdate"] = "update.wishlist:counter";
    EventBusEvent["CartCounterUpdate"] = "update.header:cart";
    EventBusEvent["CartOverviewUpdate"] = "update.cart:overview";
    EventBusEvent["AddAlerts"] = "ADD_ALERT";
    EventBusEvent["ShowEmptyCart"] = "SHOW_EMPTY_CART";
    EventBusEvent["ToggleDisclaimer"] = "TOGGLE_DISCLAIMER";
    EventBusEvent["UpdateProductMVCOption"] = "UPDATE_PRODUCT_MVC_OPTION";
})(EventBusEvent || (EventBusEvent = {}));
